// TWO QUESTIONS EVERY FORM ASKED SINCE 2023 FOLLOW THE STATE SINCE 2026-10-15 (TW-0293).
//
// David McFarland, INK SLINGERZ TATTOO STUDIO (Owasso, Oklahoma), the morning he activated for the year: "Is there a way to
// eliminate some of the pre-loaded questions that are on the waiver form that are unnecessary by Oklahoma regulations?"
// Oklahoma's rule lists nine health questions and the form asked all nine, plus two the rule never named, on every form
// since the first PDF: "Are you under the influence of drugs or alcohol?" and "Do you have a communicable disease?"
// Chris, the same hour: "it's likely fine to take items away state by state as long as we're sure we have it setup
// correctly for them."
//
// So each is the emergency contact's shape exactly: the shop's OWN switch (`public_data.ask_drugs_or_alcohol`,
// `public_data.ask_communicable_disease`), off and absent on a new row until the owner turns it on, FORCED ON where the
// shop's state's record names the question (the contract's `not_intoxicated` and `communicable_disease` items carry the
// setting; stateForms.ts settingForcedBy) — and asked on a shop with NO state at all, because a shop we cannot place is one
// we cannot answer for. The API reads the same three things (common.form_asks_default_question): the signing door refuses
// a blank only where the page asked, and the signed waiver prints a line only for an answer the body carries. Every row
// that existed on 2026-10-15 was written on before the promote, so no shop's form changed under it.
import { dayOf } from "./day";
import { settingForcedBy } from "./stateForms";

export const DRUGS_OR_ALCOHOL_SETTING = "ask_drugs_or_alcohol";
export const COMMUNICABLE_DISEASE_SETTING = "ask_communicable_disease";
export type DefaultQuestionSetting = typeof DRUGS_OR_ALCOHOL_SETTING | typeof COMMUNICABLE_DISEASE_SETTING;

/** Does this shop's page ask the question `setting` names? Its own switch (a literal true on the row, the way the API
 *  reads it), or its state keeping the question on, or no state at all. */
export function asksDefaultQuestion(
  publicData: unknown,
  state: string | null | undefined,
  setting: DefaultQuestionSetting,
  day: string = dayOf(),
): boolean {
  const own = (publicData as Record<string, unknown> | null | undefined)?.[setting] === true;
  const abbr = `${state ?? ""}`.trim();
  return own || !abbr || settingForcedBy(abbr, setting, day);
}
